export default "__VITE_ASSET__DBQY$418__"